// A customer's exact spot (Liam, 27 Oct 2026: "i need to pin as was so knew that google maps often take to wrong
// address"; https://claude.ai/artifact/JazPk5KEq5dttDN9iwETN4, Astra's check). Kept in the customer's one Map link
// (customers.maps_link) as Google's own link to a point, so it travels with everything that already carries that field:
// History and its Undo, the customer download, the bin (old-customers.ts BINNED_FIELDS), and the postcode map position
// never touches it (place-on-map.ts writes latitude and longitude only).
//
// Read back from any Google Maps link that names a point: our own (?api=1&query=LAT,LNG), a dropped pin's
// (/search/LAT,LNG or ?q=LAT,LNG), a place's (!3dLAT!4dLNG). Never the "@LAT,LNG" of a map's view: that is wherever the
// map was scrolled to, not a door.

export interface Spot { lat: number; lng: number }

const NUM = '(-?\\d{1,3}(?:\\.\\d+)?)'
const PATTERNS = [
  new RegExp(`!3d${NUM}!4d${NUM}`),
  // Not ll= (where the map was looking) and not a route's stops in /dir/ (which one is theirs?) (GPT-6.1's review).
  new RegExp(`[?&](?:query|q|destination|daddr)=${NUM}(?:,|%2C)\\s*\\+?${NUM}`, 'i'),
  new RegExp(`/(?:search|place)/${NUM}(?:,|%2C)\\+?${NUM}`, 'i'),
]

const fine = (lat: number, lng: number): boolean => Number.isFinite(lat) && Number.isFinite(lng) && Math.abs(lat) <= 90 && Math.abs(lng) <= 180 && !(lat === 0 && lng === 0)

export function placeInMapsLink(link: string | null | undefined): Spot | null {
  if (!link || !/^https:\/\//i.test(link.trim())) return null
  let text = link.trim()
  try { text = decodeURIComponent(text) } catch { /* as it is */ }
  for (const p of PATTERNS) {
    const m = p.exec(text)
    if (m) {
      const lat = Number(m[1]), lng = Number(m[2])
      if (fine(lat, lng)) return { lat: Math.round(lat * 1e6) / 1e6, lng: Math.round(lng * 1e6) / 1e6 }
    }
  }
  return null
}

// The link saved for a spot: Google's documented link to a point (developers.google.com/maps/documentation/urls).
export const spotLink = (s: Spot): string => `https://www.google.com/maps/search/?api=1&query=${s.lat},${s.lng}`

// Directions from where the phone is: to the spot when there is one, else to the address as before.
export function directionsHref(link: string | null | undefined, place: string): string | null {
  const s = placeInMapsLink(link)
  const to = s ? `${s.lat},${s.lng}` : place.trim()
  return to ? `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(to)}&travelmode=driving` : null
}
